import { createStyles } from '@mui/styles';
import { APTheme } from "../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
    BecomePartnerFailedContainer: {
        width: "auto",
        height: "100%",
        maxWidth: 576,
        margin: 'auto',
        padding: '3rem',
        [theme.breakpoints.down('lg')]: {
            width: '100%'
        }
    },
    BecomePartnerFailedCopy: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '1em',
        textAlign: 'center',
        margin: 'auto',
        maxWidth: 450
    },
    title: {
        marginBottom: 10
    },
    titleParagraph: {
        fontSize: 16,
        display: 'block',
        marginBottom: 40
    },
    callicon: {
        marginBottom: 40,
        height: '173px',
        width: '173px',
        margin: '0 auto'
    },
    callBtn: {
        margin: '0 auto 10px',
        width: 190,
        color: "#fff",
        border: "1px solid #2D91E9",
        background: "#2D91E9",
        height: 40,
        padding: 6,
        textDecoration: 'none',
        fontSize: '1.6rem',
        boxSizing: 'border-box',
        transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
        fontFamily: 'CircularStd',
        fontWeight: 500,
        lineHeight: 1.75,
        borderRadius: 20,
        textTransform: 'none',
        "&:hover": {
            background: "#3f9beb",
            border: "1px solid #3f9beb",
        },
    },
    link: {
        color: "#2d91e9",
        textDecoration: "none",
        fontFamily: "CircularStd",
        fontSize: 16,
    }
});
